import { useMemo } from 'react';
import Sticky from 'react-stickynode';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { OrderSummaryCard } from '@hivebrite/design-system/OrderSummary';
import { Skeleton } from '@hivebrite/design-system/Skeleton';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { PromoCode } from 'hb-react/shared/apps/Events/pages/Booking/components/PromoCode';
import { useBooking } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import { Card as SidebarCard } from '../Card';

export const Sidebar = ({ page }: { page: string }) => {
  const breakpoint = useBreakpoint();
  const isMobile = useMemo(() => ['s', 'm'].includes(breakpoint), [breakpoint]);

  const { flagEvPaymentsMovePromocode } = useFeatureFlag();
  const { event, cart, metadata } = useBooking();
  const { currentUser, currentNetwork } = useDefaultAppContexts();

  const eligibleForPromocodes =
    flagEvPaymentsMovePromocode &&
    !['success', 'payment'].includes(page) &&
    metadata?.eligible_for_promocodes;

  const items = useMemo(() => cart?.cart_items ?? [], [cart?.cart_items]);

  return (
    <Sticky
      enabled={!isMobile}
      top="header"
      bottomBoundary="#event-registration-container"
    >
      <Box flexDirection="column" data-testid="event-shopping-card">
        {['s', 'm'].includes(breakpoint) || page === 'payment' ? null : (
          <>{event ? <SidebarCard event={event} /> : <Skeleton />}</>
        )}

        <OrderSummaryCard
          cardProps={{
            mt: page === 'payment' ? 0 : 4,
            px: 4,
            py: 6,
            mb: { _: 0, l: 80 },
          }}
          items={items}
          locale={
            currentUser?.locale || I18n.locale || currentNetwork.locales[0]
          }
          isCompact={['s', 'm'].includes(breakpoint)}
        />

        {eligibleForPromocodes && (
          <Card p={4} mt={4}>
            <PromoCode />
          </Card>
        )}
      </Box>
    </Sticky>
  );
};
